import { useCallback, useEffect, useState } from 'react';
import { fetchAllTleMembers, tleRecordsToFeatureCollection, type TleRecord } from '../services/tleSatelliteService';

const EMPTY: GeoJSON.FeatureCollection = { type: 'FeatureCollection', features: [] };
const TWO_HOURS_MS = 2 * 60 * 60 * 1000;
const POSITION_REFRESH_MS = 10 * 1000;

export function useTleSatelliteLayer(enabled: boolean) {
  const [geoJson, setGeoJson] = useState<GeoJSON.FeatureCollection>(EMPTY);
  const [members, setMembers] = useState<TleRecord[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const list = await fetchAllTleMembers();
      // const now = new Date();
      setMembers(list);
      // setGeoJson(tleRecordsToFeatureCollection(list, now));
    } catch (e: unknown) {
      const msg = e instanceof Error ? e.message : 'TLE load failed';
      setError(msg);
      console.error('[TLE]', msg);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!enabled) {
      setGeoJson(EMPTY);
      setMembers([]);
      return;
    }
    load();
    const id = window.setInterval(load, TWO_HOURS_MS);
    return () => window.clearInterval(id);
  }, [enabled, load]);

  useEffect(() => {
    if (!enabled || members.length === 0) {
      setGeoJson(EMPTY);
      return;
    }
    const refresh = () =>
      setGeoJson(tleRecordsToFeatureCollection(members, new Date()));
    refresh();
    const id = window.setInterval(refresh, POSITION_REFRESH_MS);
    return () => window.clearInterval(id);
  }, [enabled, members]);

  return { geoJson, members, loading, error };
}